module.exports = __webpack_public_path__ + "static/media/CTLA_3-540w.8b9cb8bb.jpg";